import React, { useState } from 'react';

import useGlobalState from '../../GlobalStateContext';
import ActionButton from '../../elements/ActionButton';
import { PERMISSION, ROLE } from '../../helpers/Permissions';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import { ROLES } from '../../services/AdminPolicyService';
import axios from '../../services/MyAxios';
import AdminsList from '../admin/AdminsList';
import AffiliateRevenuePercentageList from '../affiliate/AffiliateRevenuePercentageList';
import AffiliatesList from '../affiliate/AffiliatesList';

import AffiliateOwnerDetails from './AffiliateOwnerDetails';
import AffiliateOwnerMetrics from './AffiliateOwnerMetrics';

import { GetAdminResponse } from 'Api/CRM/Responses/AdminResponse';
import useAffiliateRevenueAuth from 'crm/hooks/useAffiliateRevenueAuth';

export default function AffiliateOwnerShow() {
    const { id } = useNumberParams();
    const [affiliateOwner, setAffiliateOwner] = useState<GetAdminResponse>({} as GetAdminResponse);
    const url = '/crea/api/affiliate_owner/';
    const metricsUrl = '/crea/api/metrics/';
    const { loggedAdmin } = useGlobalState();
    const hasAffiliateRevenueAccess = useAffiliateRevenueAuth();

    useOnce(async () => setAffiliateOwner((await axios.get(`${url + id}?transformStateAndCountryFields`)).data));

    return (
        <>
            <AffiliateOwnerMetrics url={metricsUrl + id} />
            <AffiliateOwnerDetails affiliateOwner={affiliateOwner} />
            {loggedAdmin.hasRole(ROLE.MASTER_AFFILIATE_AGENT, ...ROLES.MAIN_ADMINS) ? (
                <ActionButton
                    title="Create new affiliate"
                    permissions={[PERMISSION.CREATE_AFFILIATE]}
                    url={`/affiliate_owners/${id}/create-affiliate`}
                />
            ) : null}
            <AffiliatesList cardTitle="Affiliates" affiliateOwnerId={id} />
            <ActionButton
                url={`/affiliate_owner/${id}/attach/admin`}
                title="Attach Master Affiliate Agent"
                roles={ROLES.MAIN_ADMINS}
            />
            {loggedAdmin.hasMainRole() && (
                <AdminsList source="affiliate_owner" relatedId={id} cardTitle="Master Affiliate Agents" />
            )}
            {hasAffiliateRevenueAccess && <AffiliateRevenuePercentageList id={id} isAdmin />}
        </>
    );
}
